import { Box, Stack, Typography } from '@mui/material';
import { DuplicateTransactionCard } from './DuplicateTransactionCard';

import { ButtonCard } from './ButtonCard';
import { useLocalization } from '@/hooks/useLocalization';
import { DuplicateTransactionResponse } from '@/store/transactionsApi';

interface DuplicateTransactionStepProps {
  currentStep: DuplicateTransactionResponse;
  disabled: boolean;
  onResolve: (decision: 'duplicate' | 'legitimate') => void;
}

export const DuplicateTransactionStep = ({
  currentStep,
  disabled,
  onResolve,
}: DuplicateTransactionStepProps) => {
  const { t } = useLocalization();
  const cardCount = 2;

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant='subtitle2'
          sx={{ fontWeight: 600 }}
        >
          {t('DuplicateWizard.duplicatesQuestion')}
        </Typography>
        <Typography variant='body2'>
          {t('DuplicateWizard.reviewHint')}
        </Typography>
      </Box>

      <Stack
        flexDirection={{ xs: 'column', sm: 'row' }}
        gap={2}
        sx={{ mb: 3 }}
      >
        {Array.from(new Array(cardCount)).map((_, index) => (
          <DuplicateTransactionCard
            key={`${String(currentStep.MinWealthAccountTransactionId)}-${String(index)}`}
            currentDuplicateSet={currentStep}
            title={t('DuplicateWizard.transactionNumber', {
              number: index + 1,
            })}
          />
        ))}
      </Stack>

      <Box>
        <Typography
          variant='subtitle1'
          sx={{ fontWeight: 600 }}
        >
          {t('DuplicateWizard.decisionTitle')}
        </Typography>

        <Typography
          variant='body2'
          color='text.secondary'
          sx={{ mb: 2.5 }}
        >
          {t('DuplicateWizard.decisionHint')}
        </Typography>

        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
        >
          <ButtonCard
            fullWidth
            onClick={() => {
              onResolve('legitimate');
            }}
            disabled={disabled}
            label={t('DuplicateWizard.actionLegitimate')}
            sublabel={t('DuplicateWizard.actionLegitimateHint')}
          />

          <ButtonCard
            fullWidth
            onClick={() => {
              onResolve('duplicate');
            }}
            disabled={disabled}
            label={t('DuplicateWizard.actionDuplicate')}
            sublabel={t('DuplicateWizard.actionDuplicateHint')}
          />
        </Stack>
      </Box>
    </Box>
  );
};
